import { Typography } from 'antd'

interface Props {
  title: string
  description?: string
}

export default function ComingSoon({ title, description }: Props) {
  return (
    <div
      style={{
        height: '70vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#8c8c8c',
      }}
    >
      <Typography.Title level={3} style={{ color: '#595959' }}>
        {title}
      </Typography.Title>
      <Typography.Text type="secondary">{description || '第二阶段功能，敬请期待'}</Typography.Text>
    </div>
  )
}
